import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ViewChild, SimpleChanges } from '@angular/core';
import { TreeInputModel } from '../../../@core/models/treeInputModel.entity';
import { TreeNode, ITreeOptions } from '../../../../../node_modules/angular-tree-component/dist/defs/api';
import { DataService } from '../../../@core/data/data.service';
import { TranslateJsonService } from 'app/@core/data/translate-json.service';
import { Workspace } from 'app/@core/models/workspace.data.entity';
import { VehicleStatusEnum } from 'app/@core/enum/vehicle-status.enum';

@Component({
    selector: 'focus-tree-input',
    styleUrls: ['./treeInput.component.scss'],
    templateUrl: './treeInput.component.html',
})
export class TreeInputComponent implements OnDestroy, OnInit {
    @ViewChild('treeContent') treeContent: TreeNode;
    @ViewChild('overlay') overlay;
    @ViewChild('table') table;
    @ViewChild('inputTrigger') inputTrigger;

    // Properts
    @Input('selectedNodeName') selectedNodeName: string;
    @Input('contentNodes') contentNodes: TreeInputModel[] = [];
    @Input('selectedNodes') selectedNodes: number[] = [];
    @Input('contentName') contentName: string = "Conteúdo";
    @Input('overlayPanelWidth') overlayPanelWidth: string = '450px';
    @Input('overlayPanelHeight') overlayPanelHeight: string = '300px';
    @Input('checkBox') checkBox: boolean = false;
    @Input('triStateChk') triStateChk: boolean = false;
    @Input('cascadeUpToParent') cascadeUpToParent: boolean = false;
    @Input('multChk') multChk: boolean = false;
    @Input('allChidren') allChidren: boolean = false;
    @Input('treeMode') treeMode: boolean = true;
    @Input() selectOnlyfromOneCustomer: boolean = false;
    @Input('loadedContent') loadedContent: boolean = false;
    @Input('pendingContent') set pendingContent(value : boolean){
        this.lockedContent = true
        if(!value){
            this.lockedContent = false;
        }else{
            this.lockedContent = true;
        }
    }
    @Input() isTelemetryPage: boolean = false;
    @Input('isDisabled') isDisabled: boolean = false;
    @Input('showSelectAll') showSelectAll: boolean = false
    @Input('isTripsPage') isTripsPage: boolean  = false
    @Input('lazyPagination') lazyPagination: boolean = false
    @Input('totalRecords') totalRecords: number = 0
    @Input('loadingRemote') loadingRemote: boolean = false
    @Input('rowsPerPage') rowsPerPage: number = 10

    // Events
    @Output('changedNodes') changedNodes: EventEmitter<number[]> = new EventEmitter();
    @Output('changedNodeInfo') changedNodeInfo: EventEmitter<any[]> = new EventEmitter();
    @Output('submitCustomerEmit') submitCustomerEmit: EventEmitter<any> = new EventEmitter()
    @Output('panelOpened') panelOpened: EventEmitter<void> = new EventEmitter();
    @Output('lazyLoad') lazyLoad: EventEmitter<{ first: number, rows: number }> = new EventEmitter();
    @Output('searchQuery') searchQuery: EventEmitter<string> = new EventEmitter();

    // Sem uso
    @Input('selectedContent') selectedContent: number;

    public allContent: TreeNode[];
    public options: ITreeOptions = { useCheckbox: this.checkBox };
    public displayContent: boolean = false;
    public lockedContent: boolean = true;
    private skipNextTableLazyLoad = false;
    private pendingPanelOpen = false;

    paramTranslateFilter = {value: this.contentName};

    checkDefaultCustomer

    constructor(
        private dataService: DataService,
        protected translateJsonService: TranslateJsonService
    ){

    }

    ngOnInit(){
        this.showSelectAll = false
        this.initializeContent();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['contentNodes'] || changes['loadedContent']) {
            this.initializeContent();
        }

        if (!this.lazyPagination || !this.pendingPanelOpen || this.loadingRemote) {
            return;
        }

        const loadingFinished = changes['loadingRemote'] &&
            changes['loadingRemote'].previousValue &&
            !changes['loadingRemote'].currentValue;

        const dataArrived = (changes['contentNodes'] || changes['totalRecords']) &&
            (this.totalRecords > 0 || this.contentNodes.length > 0);

        if (loadingFinished || dataArrived) {
            this.openPendingPanel();
        }
    }
    
    ngOnDestroy(){}

    private sortCustomersOrderByName(customers: TreeInputModel[]) {
        customers.sort(function (a, b) {
            return (a.name || '').localeCompare(b.name || '', 'pt-BR', { sensitivity: 'base' });
        });
    }

    private initializeContent() {
        if (this.loadedContent && this.treeMode) {
            setTimeout(() => {
                if (this.isTripsPage) {
                    this.verifyCustomerProfileIdSelectionForTripsPage();
                }
            });
            this.sortCustomersOrderByName(this.contentNodes);           
            this.allContent = this.convertTreeContent(this.contentNodes);
            this.displayContent = true;
        }
        if (this.loadedContent && !this.treeMode) {
            this.displayContent = true;
        }
    }

    /**
     * Desseleciona todos os Nodes ativos em Arvores
     */
    public clearAllSelectedNodes(){
        this.treeContent.treeModel.setActiveNode(false, false);
        this.selectedNodes=[];
        this.changedNodes.emit([]);
        this.changedNodeInfo.emit([]);
    }

    /**
     * Desseleciona todos os ITENS ativos em TABELAS
     */
    public clearAllSelectedItens(){
        this.selectedNodes = [];
        this.changedNodes.emit([]);
        this.changedNodeInfo.emit([]);
    }

    preSelectedNodes() {
        this.selectedNodes = []
        this.contentNodes.forEach(node => {
            if(node.parentId && node.parentId == this.checkDefaultCustomer) {
                this.selectedNodes.push(node.id)                
            } else {
                if(node.id === this.checkDefaultCustomer) {
                    this.selectedNodes.push(node.id)
                }
            }

        })
        this.activeSelectedNodes()
        this.submitCustomerEmit.emit(this.selectedNodes)
    }

    public getInactiveText(statusCode: number) {
        return this.translateJsonService.getTranslateSubs('FILTER-GLOBAL.' +  VehicleStatusEnum[statusCode])
    }

    public selectAllItems() {
        this.selectedNodes = [];
        this.contentNodes.forEach(node => {
            this.selectedNodes.push(node.id)
        })
    }

    public checkUncheckAll(event) {
        event.target.checked ? this.selectAllItems() : this.clearAllSelectedItens()
    }

    /**
     * Recebe todos itens do componente pai, verifica os que são Node Raiz,
     * e todos os respectivos Node Filhos.
     * @param _content Recebe uma lista de TreeInputModel 
     */
    public convertTreeContent(_content: TreeInputModel[]): TreeNode[] {
        let result: TreeNode[] = [];
  
        _content.forEach((content : TreeInputModel) => {
          if(content.parentId == null){
            result.push(this.buildNode(content, _content));
          }else{
            let parent = _content.find((parentChild : TreeInputModel) => {
                if(parentChild.id == content.parentId){
                    return true
                }else{
                    return false
                }
            });
            
            if(!parent){
              result.push(this.buildNode(content, _content));
            }
          }
        })
  
        return result;
    }

    /**
     * Seleciona automatica os Nodes pré definidos.
     */
    public activeSelectedNodes(){
        if(this.selectedNodes && this.treeContent){
            const nodeIndex = {};
            const indexNodes = (nodes) => {
                nodes.forEach((node) => {
                    nodeIndex[node.id] = true;
                    if (node.children) {
                        indexNodes(node.children);
                    }
                });
            };
            indexNodes(this.treeContent.treeModel.roots);

            const activeIds = {};
            this.selectedNodes.forEach((nodeId : number) => {
                if (nodeIndex[nodeId]) {
                    activeIds[nodeId] = true;
                }
            });

            this.treeContent.treeModel.activeNodeIds = Object.assign({}, this.treeContent.treeModel.activeNodeIds, activeIds);
        }
    }

    /**
     * Monta o Node no formato TreeNode, além de pesquisar pelos seus respectivos nodes filhos.
     * @param content Node a ser construído
     * @param _content Restante da Arvore para verificar seus filhos.
     */
    public buildNode(content : TreeInputModel, _content : TreeInputModel[]){
        return {id: content.id, name: content.name, children: this.searchChilds(content, _content)};
    }

    /**
     * Recebe um Content e verifica dentro da lista todos os filhos do mesmo.
     * Função Recursiva
     * @param content Node Raiz
     * @param _content Restante da Arvore para verificar seus filhos.
     */
    public searchChilds(content : TreeInputModel, _content : TreeInputModel[]){
        let tree: any[] = [];
        let parentList: TreeInputModel[] = _content.filter((_content_ : TreeInputModel) => _content_.parentId == content.id);

        if(parentList.length > 0){
            parentList.forEach((parentContentChild : TreeInputModel) => {
                tree.push(this.buildNode(parentContentChild, _content));
            })
        }

        return tree;
    }

    /*
    * Ação chamada sempre que um Node (Filial) é selecionado na Tree.
    * Recupera todas as Nodes da Tree.
    */
    public selectedNode(node) {
        const activeNodeIds = node.treeModel.activeNodeIds;
        
        const validIds = {};
        const indexIds = (nodes) => {
            nodes.forEach((n) => {
                validIds[n.id] = true;
                if (n.children) {
                    indexIds(n.children);
                }
            });
        };
        indexIds(node.treeModel.roots);

        return this.selectedNodes = Object.keys(activeNodeIds)
            .filter((id) => activeNodeIds[id] && validIds[id])
            .map((id) => Number(id));
    }

    public checkedTable(event, nodeId: number){
        if(!this.selectedNodes) this.selectedNodes = [];

        if(event.target.checked){
            this.selectedNodes.push(nodeId);
        }else{
            let i = this.selectedNodes.indexOf(nodeId);
            this.selectedNodes.splice(i, 1);
        }

        this.changedNodes.emit(this.selectedNodes);
    }

    public checkingOnlyOneNode(node) {
        this.selectedNodeName = node.imei ? `${node.name} - ${node.imei}` : node.name;
        this.selectedNodes = [];
        this.selectedNodes.push(node.id);
        this.changedNodes.emit([node.id]);
        this.changedNodeInfo.emit([node]);
        this.overlay.hide();
    }

    public verifyCheckedTable(nodeId: number){
        if(this.selectedNodes){
            if(this.selectedNodes.find((id) => id == nodeId)){
                return true;
            }else{
                return false;
            }
        }else{
            return false;
        }
    }

    verifyCustomerProfileIdSelectionForTripsPage() {
        let ws: Workspace = this.dataService.getWorkspace()
        this.checkDefaultCustomer = ws.currentUser.customerChild
        this.preSelectedNodes()
    }

    /**
     * Os códigos abaixo realizam a função de fazer o 'tri-state' do checkbox da Árvore de Empresas
     * e do multiselect
     * @param node 
     * @param $event 
     */
    public checked(node, $event) {
        if (this.multChk) {

            const parentExists = node.parent && node.parent.data;
            const selectedNodesIncludesParent = this.selectedNodes && this.selectedNodes.includes(node.parent.data.id);
            const allSelectedInParent = this.selectedNodes && this.selectedNodes.every(id => parentExists && node.parent.data.children.map(customer => customer.id).includes(id));
            
            if (this.selectOnlyfromOneCustomer &&
                (node.parent.parent == null || (!selectedNodesIncludesParent && !allSelectedInParent))) {
                this.treeContent.treeModel.collapseAll();
                this.clearAllSelectedNodes();
            }
    
            this.updateChildNodesCheckBox(node, $event.target.checked);
            if (this.triStateChk) {
                if (this.cascadeUpToParent) {
                    this.updateParentNodesCheckBox(node.parent);
                } else {
                    this.updateParentNodesIndeterminate(node.parent);
                }
            } else {
                node.treeModel.setActiveNode(node, $event.target.checked, true);
            }
        } else {
            node.treeModel.setActiveNode(node, $event.target.checked, true);
        }
    
        this.changedNodes.emit(this.selectedNode(node));
        if (!node.hasChildren && !$event.target.checked) {
            node.treeModel.setActiveNode(node, false, true);
            if (this.selectedNode(node).length < 1) {
                this.changedNodes.emit([]);
            }
        }
    }
    
    public updateChildNodesCheckBox(node, checked) {
        node.treeModel.setActiveNode(node, checked, true);

        if (!node.children || node.children.length === 0) {
            return;
        }

        const descendantIds = {};
        const collectIds = (parent) => {
            if (!parent.children) {
                return;
            }
            parent.children.forEach((child) => {
                descendantIds[child.id] = checked;
                collectIds(child);
            });
        };
        collectIds(node);

        node.treeModel.activeNodeIds = Object.assign({}, node.treeModel.activeNodeIds, descendantIds);
    }
    
    public updateParentNodesCheckBox(node) {
        if (node && node.level > 0 && node.children) {
            let allChildChecked = true;
            let noChildChecked = true;
            for (let child of node.children) {
                if (!child.isActive) {
                    allChildChecked = false;
                } else if (child.isActive) {
                    noChildChecked = false;
                }
            }
            
            if (allChildChecked) {
                node.treeModel.setActiveNode(node, true, true);
                node.data.indeterminate = false;
            } else if (noChildChecked) {
                node.treeModel.setActiveNode(node, false, true);
                node.data.indeterminate = false;
            } else {
                node.treeModel.setActiveNode(node, true, true);
                node.data.indeterminate = true;
            }
    
            this.updateParentNodesCheckBox(node.parent);
        }
    }

    public updateParentNodesIndeterminate(node) {
        if (node && node.level > 0 && node.children) {
            const someChildActive = node.children.some((child) => child.isActive || child.data.indeterminate);
            const allChildActive = node.children.every((child) => child.isActive);

            node.data.indeterminate = someChildActive && (!allChildActive || !node.isActive);

            this.updateParentNodesIndeterminate(node.parent);
        }
    }

    public showPanel() {
        this.openOverlayPanel();
    }

    private getOverlayTarget(): HTMLElement {
        return this.inputTrigger ? this.inputTrigger.nativeElement : null;
    }

    private openOverlayPanel(event?: Event): void {
        const target = this.getOverlayTarget();
        if (!target) {
            return;
        }

        const overlayEvent = event || ({ type: 'click' } as Event);
        this.overlay.show(overlayEvent, target);
    }

    private openPendingPanel(): void {
        if (!this.pendingPanelOpen) {
            return;
        }

        this.pendingPanelOpen = false;

        setTimeout(() => {
            this.openOverlayPanel();
            this.activeSelectedNodes();
        });
    }

    public onInputClick(event: Event) {
        if (this.lazyPagination && this.loadingRemote) {
            return;
        }

        if (this.lazyPagination && this.totalRecords === 0 && this.contentNodes.length === 0) {
            this.pendingPanelOpen = true;
            this.skipNextTableLazyLoad = true;
            this.emitLazyLoad({ first: 0, rows: this.rowsPerPage });
            return;
        }

        const target = this.getOverlayTarget();
        if (target) {
            this.overlay.toggle(event, target);
        } else {
            this.overlay.toggle(event);
        }
        this.activeSelectedNodes();
    }

    public onPanelShow() {
        if (!this.lazyPagination) {
            this.panelOpened.emit();
        }
    }

    public emitLazyLoad(event: { first: number, rows: number }) {
        this.lazyLoad.emit(event);
    }

    public onTableLazyLoad(event: any) {
        if (!this.lazyPagination) {
            return;
        }

        if (this.skipNextTableLazyLoad && event.first === 0) {
            this.skipNextTableLazyLoad = false;
            return;
        }

        this.emitLazyLoad({ first: event.first, rows: event.rows });
    }

    public onTableFilter(value: string) {
        if (this.lazyPagination) {
            this.searchQuery.emit(value || '');
            return;
        }

        if (this.table) {
            this.table.filter(value, 'name', 'contains');
        }
    }

    public onClearTableFilter(filterInput: HTMLInputElement) {
        filterInput.value = '';
        this.onTableFilter('');
    }

  public filterTree(name: string)
  {
    if(name.length>0) {
      this.treeContent.treeModel.filterNodes(name);
    } else {
      this.treeContent.treeModel.filterNodes('');
      this.treeContent.treeModel.collapseAll();
    }
  }

}
